import * as v from 'valibot';

const pslfEstimatorSchema = v.object({
  federalLoanTime: v.pipe(
    v.string('Required'),
    v.picklist(['before-october-2007', 'after-october-2007'])
  ),
  householdIncome: v.pipe(
    v.number('Income must be greater than $0'),
    v.minValue(0.01, 'Income must be greater than $0')
  ),
  householdSize: v.pipe(
    v.number('Family size must be 1 or greater'),
    v.minValue(1, 'Family size must be 1 or greater')
  ),
  madePayments: v.number('Required'),
  academicDegree: v.pipe(
    v.string('Required'),
    v.picklist(['undergradOnly', 'GradOnly', 'undergradGrad'], 'Please select a response')
  ),
});

const idrEstimatorSchema = v.object({
  federalLoanTime: v.pipe(
    v.string('Required'),
    v.picklist(['before-october-2007', 'after-october-2007'])
  ),
  householdIncome: v.pipe(
    v.number('Income must be greater than $0'),
    v.minValue(0.01, 'Income must be greater than $0')
  ),
  householdSize: v.pipe(
    v.number('Family size must be 1 or greater'),
    v.minValue(1, 'Family size must be 1 or greater')
  ),
  madePayments: v.number('Required'),
  affordPayments: v.pipe(
    v.string('Required'),
    v.picklist(['yes', 'no'], 'Please select a response')
  ),
});

const strategyFinderFormSchema = v.object({
  payoffGoal: v.pipe(
    v.string('Please select a response'),
    v.picklist(['quick', 'slow'], 'Please select a response')
  ),
  affordPayments: v.pipe(
    v.string('Please select a response'),
    v.picklist(['yes', 'no'], 'Please select a response')
  ),
  federalLoanTime: v.pipe(
    v.string('Please select a response'),
    v.picklist(['before-october-2007', 'after-october-2007'], 'Please select a response')
  ),
  currentlyWorkingToward: v.pipe(
    v.string('Please select a response'),
    v.picklist(['yes', 'no-and-not-interested', 'no-but-want-learn'], 'Please select a response')
  ),
  currentForgivenessProgram: v.optional(
    v.pipe(
      v.string('Please select a program'),
      v.picklist(
        ['PublicServiceLoanForgiveness', 'TeacherLoanForgiveness', 'IncomeDrivenLoanForgiveness'],
        'Please select a program'
      )
    )
  ),
  madePayments: v.optional(v.number('Required')),
  employmentType: v.pipe(
    v.string('Please select any that apply'),
    v.picklist(
      [
        'government-tribal-nonprofit',
        'teacher',
        'other-private-sector',
        'teacher&government-tribal-nonprofit',
      ],
      'Please select any that apply'
    )
  ),
  madeLimitedWaiverPayments: v.optional(v.number('Required')),
  planInGov: v.optional(
    v.pipe(
      v.string('Please select a response'),
      v.picklist(['for-10-years-more', 'not-for-10-years'], 'Please select a response')
    )
  ),
  planAsTeacher: v.optional(
    v.pipe(
      v.string('Please select a response'),
      v.picklist(['for-5-years-and-more', 'less-than-5-years'], 'Please select a response')
    )
  ),
  householdIncome: v.pipe(
    v.number('Income must be greater than $0'),
    v.minValue(0.01, 'Income must be greater than $0')
  ),
  householdSize: v.pipe(
    v.number('Family size must be 1 or greater'),
    v.minValue(1, 'Family size must be 1 or greater')
  ),
  residenceState: v.string('Required'),
  academicDegree: v.pipe(
    v.string('Please select a response'),
    v.picklist(['undergradOnly', 'GradOnly', 'undergradGrad'], 'Please select a response')
  ),
});

export { pslfEstimatorSchema, idrEstimatorSchema, strategyFinderFormSchema };

export default null; // silence a false warning
